<footer class="footer">
    <div class="footer-div">
        <div class="footer-column">
            <ul>
              <li>FAQ</li>
              <li>PMA Intro</li>
              <li>Membership Agreement</li>
              <li>Producer Application</li>
              <li>Ready to Join?</li>
            </ul>
          </div>
          <div class="footer-center">
            <h2>LITTLE FARM</h2>
            <h2>ASSOCIATION</h2>
            <p *ngIf="storeDetailsJson['second_footer']">{{storeDetailsJson['second_footer']['copyRight']['copyRightText']}}</p>
          </div>
          <div class="footer-column">
            <ul>
              <li>Directory</li>
              <li>Recipes</li>
              <li>Events</li>
              <li>Blog</li>
            </ul>
          </div>
    </div>
  </footer>
  